import { useQuery } from '@tanstack/react-query';
import { getSuppliers } from '../api';

export function useSuppliers(filters?: {
  category?: string;
  search?: string 
}) {
  return useQuery({
    queryKey: ['suppliers', filters],
    queryFn: () => getSuppliers(filters),
    staleTime: 60_000,
  });
}
